<template>
  <v-card
    elevation="0"
    class="extension-candidate-courses"
  >
    <v-card-title>
      <p class="pa-0 ma-0 text--secondary text-sm">
        延長
      </p>
      <v-spacer />
      <v-btn
        v-show="opener"
        fab
        icon
        :ripple="false"
        class="mr-2"
        @click.prevent="$emit('reload')"
      >
        <v-icon>
          {{ icons.mdiReload }}
        </v-icon>
      </v-btn>

      <v-btn
        icon
        fab
        :ripple="false"
        @click="opener = !opener"
      >
        <v-icon>
          {{ icons.mdiCogOutline }}
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-expand-transition>
      <v-card-text v-show="opener">
        <div v-if="hasExtensionCandidateCourses">
          <div
            v-for="(extensionCandidate, extensionCandidateIdx) in extensionCandidates"
            :key="`extensionCandidates[${extensionCandidateIdx}]`"
            class="mb-5"
          >
            <v-chip
              class="mb-2 v-chip-light-bg accent--text font-weight-semibold"
            >
              <v-icon
                class="me-1"
                color="accent"
                size="18"
              >
                {{ icons.mdiLightbulbOutline }}
              </v-icon>
              {{ `候補 ${extensionCandidateIdx + 1}` }}
            </v-chip>
            <!-- eslint-disable vue/v-on-event-hyphenation -->
            <order-card
              v-model="extensionCandidate.courseHistory.value"
              :vendibles="courses"
              :size="extensionCandidate.courseHistory.size"
              :removable="false"
              :hide-vending-contributors="true"
              @update:vendibleId="extensionCandidate.courseHistory.value.vendibleId = $event"
              @update:sellingPrice="extensionCandidate.courseHistory.value.sellingPrice = $event"
              @update:size="extensionCandidate.courseHistory.size = $event"
            >
              <template #default>
                <v-expansion-panels
                  v-if="extentionDescriptions(extensionCandidateIdx)"
                  flat
                  class="mt-2"
                >
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      hide-actions
                      class="px-2 pt-1"
                    >
                      <div>
                        <div class="d-flex align-center">
                          <p class="pa-0 ma-0 text--disabled text-sm">
                            <v-icon>
                              {{ icons.mdiAttachment }}
                            </v-icon>
                            {{ extentionDescriptions(extensionCandidateIdx) }}
                          </p>
                        </div>

                        <nomination-display
                          v-if="currentNominationsTempOfArray[extensionCandidateIdx].length > 0"
                          :nomination-histories="currentNominationsTempOfArray[extensionCandidateIdx]"
                        />
                        <div
                          v-else
                          class="ml-2"
                        >
                          ...
                        </div>
                      </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <!-- eslint-disable vue/v-on-event-hyphenation -->
                      <order-card
                        v-for="(nominationHistory, nominationHistoryIdx) in extensionCandidate.nominationHistories"
                        :key="`extensionCandidates${extensionCandidateIdx}_nominationHistories[${nominationHistoryIdx}]_${extensionCandidate.nominationHistories.length}`"
                        v-model="nominationHistory.value"
                        :vendibles="nominations"
                        :users="users"
                        :hide-vending-contributors="true"
                        class="mb-4"
                        @update:vendibleId="nominationHistory.value.vendibleId = $event"
                        @update:sellingPrice="nominationHistory.value.sellingPrice = $event"
                        @update:taxCharge="nominationHistory.value.taxCharge = $event"
                        @update:vendibleRecipientsAttributes="nominationHistory.value.vendibleRecipientsAttributes = $event"
                        @update:size="nominationHistory.size = $event"
                        @remove="$emit('remove:nomination-history-temp', extensionCandidateIdx, nominationHistory.value)"
                      />

                      <order-card
                        v-for="(itemHistory, itemHistoryIdx) in extensionCandidate.itemHistories"
                        :key="`extensionCandidates${extensionCandidateIdx}_itemHistories[${itemHistoryIdx}]_${extensionCandidate.itemHistories.length}`"
                        v-model="itemHistory.value"
                        :vendibles="items"
                        :users="users"
                        :size="itemHistory.size"
                        :hide-vending-contributors="true"
                        class="mb-4"
                        @update:vendibleId="itemHistory.value.vendibleId = $event"
                        @update:vendibleType="itemHistory.value.vendibleType = $event"
                        @update:isNonExistVendible="itemHistory.value.isNonExistVendible = $event"
                        @update:vendibleName="itemHistory.value.vendibleName = $event"
                        @update:sellingPrice="itemHistory.value.sellingPrice = $event"
                        @update:taxCharge="itemHistory.value.taxCharge = $event"
                        @update:vendingContributionsAttributes="itemHistory.value.vendingContributionsAttributes = $event"
                        @update:isArbitraryVendingContribution="itemHistory.isArbitraryVendingContribution = $event"
                        @update:vendibleRecipientsAttributes="itemHistory.value.vendibleRecipientsAttributes = $event"
                        @update:size="itemHistory.size = $event"
                        @remove="$emit('remove:item-history-temp', extensionCandidateIdx, itemHistory.value)"
                      />

                      <order-card
                        v-for="(newHistory, newHistoryIdx) in extensionCandidate.newHistories"
                        :key="`extensionCandidates${extensionCandidateIdx}_newHistories[${newHistoryIdx}]_${extensionCandidate.newHistories.length}`"
                        v-model="newHistory.value"
                        :vendibles="filteredVendibles(extensionCandidateIdx)"
                        :users="users"
                        :size="newHistory.size"
                        :hide-vending-contributors="true"
                        class="mb-4"
                        @update:vendibleId="newHistory.value.vendibleId = $event"
                        @update:vendibleType="newHistory.value.vendibleType = $event"
                        @update:isNonExistVendible="newHistory.value.isNonExistVendible = $event"
                        @update:vendibleName="newHistory.value.vendibleName = $event"
                        @update:sellingPrice="newHistory.value.sellingPrice = $event"
                        @update:taxCharge="newHistory.value.taxCharge = $event"
                        @update:vendingContributionsAttributes="newHistory.value.vendingContributionsAttributes = $event"
                        @update:isArbitraryVendingContribution="newHistory.isArbitraryVendingContribution = $event"
                        @update:vendibleRecipientsAttributes="newHistory.value.vendibleRecipientsAttributes = $event"
                        @update:size="newHistory.size = $event"
                        @remove="$emit('remove:new-history-temp', extensionCandidateIdx, newHistory.value)"
                      />
                      <v-card
                        elevation="0"
                        class="d-flex align-center justify-center"
                      >
                        <v-btn
                          fab
                          icon
                          large
                          :ripple="false"
                          color="primary"
                          @click="customAddVendingHistoryTemp(extensionCandidateIdx)"
                        >
                          <v-icon>
                            {{ icons.mdiPlus }}
                          </v-icon>
                        </v-btn>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </template>
            </order-card>

            <v-btn
              :ripple="false"
              color="primary"
              class="w-full mt-1 text-center"
              :disabled="!canCreateTable || (!extensionCandidate.courseHistory.value.vendibleId && !extensionCandidate.courseHistory.value.sellingPrice)"
              @click="$emit('order', vendingHistoriesTempOfArray[extensionCandidateIdx])"
            >
              作成
            </v-btn>
          </div>
        </div>

        <div v-else>
          <v-skeleton-loader
            v-if="isInitializing"
            height="160"
            type="card"
          />

          <p
            v-else
            class="ma-0 ml-2 pa-0 text-sm text--secondary"
          >
            延長候補はありません
          </p>
        </div>
      </v-card-text>
    </v-expand-transition>
  </v-card>
</template>

<script>
import {
  ref,
  computed,
  inject,
  watch,
  onUnmounted,
} from '@vue/composition-api'
import {
  mdiCogOutline,
  mdiAttachment,
  mdiPlus,
  mdiLightbulbOutline,
  mdiReload,
} from '@mdi/js'
import {
  map,
  each,
  cloneDeep,
  filter,
  find,
  chain,
  every,
  first,
} from 'lodash'
import useVendingHistory from '@/views/composable/useVendingHistory'
import useCurrentData from '@/views/composable/useCurrentData'
import OrderCard from '@/views/components/table/OrderCard/OrderCard.vue'
import NominationDisplay from '@/views/components/table/NominationDisplay.vue'

export default {
  components: {
    OrderCard,
    NominationDisplay,
  },
  props: {
    tableId: {
      type: [Number, String],
      validator: value => !Number.isNaN(Number(value)),
      required: true,
    },
    tableNumber: {
      type: [Number, String],
      validator: value => !Number.isNaN(Number(value)),
      required: true,
    },
    tablePrefix: {
      type: String,
      default: '',
    },
    tableSuffix: {
      type: String,
      default: '卓',
    },
    customerCount: {
      type: [Number, String],
      validator: value => !Number.isNaN(Number(value)),
      required: true,
    },
    extensionCandidates: {
      type: Array,
      required: true,
    },
    isInitializing: {
      type: Boolean,
      required: true,
    },
    canCreateTable: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const courses = inject('courses', [])
    const nominations = inject('nominations', [])
    const items = inject('items', [])
    const vendibles = inject('vendibles', [])
    const users = inject('users', [])

    const { currentClub } = useCurrentData()

    const opener = ref(true)

    const {
      addVendingHistoryTemp,
      setVendingContributionsAttributes,
    } = useVendingHistory()

    const hasExtensionCandidateCourses = computed(() => {
      return props.extensionCandidates.length > 0
    })

    const vendingHistoriesTempOfArray = computed(() => {
      return map(props.extensionCandidates, extensionCandidate => {
        const vendingHistoriesTemp = [
          extensionCandidate.courseHistory,
          ...extensionCandidate.nominationHistories,
          ...extensionCandidate.itemHistories,
          ...extensionCandidate.newHistories,
        ]

        return vendingHistoriesTemp
      })
    })

    // NOTE: 延長候補対象の名前を表示する。currentClub.nominationAlias, currentClub.itemAlias/で結合して文字列を返す
    const extentionDescriptions = idx => {
      const extensionCandidate = props.extensionCandidates[idx]

      const hasNominationHistories = extensionCandidate.nominationHistories.length > 0
      const hasItemHistories = extensionCandidate.itemHistories.length > 0

      // 両方ともあればcurrentClub.nominationAlias, currentClub.itemAlias/で結合して文字列を返す
      if (hasNominationHistories && hasItemHistories) {
        return [currentClub.value.nominationAlias, currentClub.value.itemAlias].join('/')
      }

      if (hasNominationHistories) {
        return currentClub.value.nominationAlias
      }

      if (hasItemHistories) {
        return currentClub.value.itemAlias
      }

      return ''
    }

    const filteredVendibles = index => {
      // extensionCandidatesのnominationHistoriesとitemHistoriesが両方存在していたらそvendiblesをそのまま返す
      const hasNominationHistories = props.extensionCandidates[index]?.nominationHistories?.length > 0
      const hasItemHistories = props.extensionCandidates[index]?.itemHistories?.length > 0

      if (hasNominationHistories && hasItemHistories) {
        return vendibles.value
      }

      // 片方しかない時はそれぞれのvendiblesを返す
      if (hasNominationHistories) {
        return nominations.value
      }

      if (hasItemHistories) {
        return items.value
      }

      return []
    }

    // NOTE: 現在選択中(このcompのOrderCardから選択している最中)の指名ユーザーからNominationDisplayを表示させる
    const currentNominationsTempOfArray = computed(() => {
      return map(props.extensionCandidates, extensionCandidate => {
        const validNominationHistories = filter(
          extensionCandidate.nominationHistories,
          nominationHistory => {
            return every(nominationHistory.value.vendibleRecipientsAttributes, 'userId')
              && nominationHistory.value.vendibleId
          },
        )

        return chain(validNominationHistories)
          .map(nominationHistory => {
            // NOTE:
            // vendibleRecipientsは複数想定だが指名のときは一つだけしか基本的に持たない(入力のUIもそうなってる)
            // そのためfirstをつかっている
            const nominee = find(users.value, user => Number(user.id) === Number(first(nominationHistory.value.vendibleRecipientsAttributes)?.userId))
            const targetNomination = find(nominations.value, nomination => Number(nomination.id) === Number(nominationHistory.value.vendibleId))

            if (!(nominee && targetNomination)) return null

            const vendingHistoryMock = {
              id: Math.random(),
              meta: {
                color: targetNomination.attributes?.color,
              },
              attributes: {
                vendibleRecipients: {
                  data: [{
                    attributes: {
                      recipient: { data: nominee },
                    },
                  }],
                },
                vendibleId: targetNomination.id,
              },
            }

            return vendingHistoryMock
          })
          .compact()
          .value()
      })
    })

    const hasNominationHistories = index => {
      return props.extensionCandidates[index]?.nominationHistories?.length > 0
    }

    const hasItemHistories = index => {
      return props.extensionCandidates[index]?.itemHistories?.length > 0
    }

    const targetVendibleType = index => {
      if (hasNominationHistories(index) && hasItemHistories(index)) {
        return ''
      }

      if (hasNominationHistories(index)) {
        return 'Nomination'
      }

      if (hasItemHistories(index)) {
        return 'Item'
      }

      return null
    }

    const customAddVendingHistoryTemp = index => {
      const extensionCandidate = props.extensionCandidates[index]
      // デフォルトでNominationを設定する場合
      const vendibleType = targetVendibleType(index)
      const newHistoryTemp = addVendingHistoryTemp({ vendibleType })

      extensionCandidate.newHistories.push(newHistoryTemp)
    }

    // NOTE: 親の客数変更に依存してsizeも変える
    watch(() => props.customerCount, (newVal, _prev) => {
      each(props.extensionCandidates, extensionCandidate => {
        // eslint-disable-next-line no-param-reassign
        extensionCandidate.courseHistory.size = newVal
      })
    })

    // NOTE: 販売貢献人をvendingHistoryTempに自動セットするwatch
    watch(() => cloneDeep(vendingHistoriesTempOfArray.value), (_newVal, _prevVal) => {
      each(vendingHistoriesTempOfArray.value, vendingHistoriesTemp => {
        setVendingContributionsAttributes({
          targetVendingHistoriesTemp: vendingHistoriesTemp,
        })
      })
    })

    const resetComp = () => {
      opener.value = 0
    }
    onUnmounted(() => resetComp())

    return {
      // inject
      courses,
      nominations,
      items,
      users,

      // data
      opener,
      // computed
      hasExtensionCandidateCourses,
      currentNominationsTempOfArray,
      vendingHistoriesTempOfArray,

      // methods
      addVendingHistoryTemp,
      extentionDescriptions,
      customAddVendingHistoryTemp,
      filteredVendibles,

      icons: {
        mdiCogOutline,
        mdiAttachment,
        mdiPlus,
        mdiLightbulbOutline,
        mdiReload,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.v-expansion-panel::before {
  box-shadow: none !important;
}
</style>
